import {gql} from '@apollo/client'

export const GET_COUNTRIES_CODE = gql`
  query getCountries {
    getCountries {
      id
      name
      shortName
      phoneCode
      currency
      flagImage
      isActive
    }
  }
`

export const GET_INITIAL_DATA = gql`
  query getInitialData {
    getInitialData
  }
`

export const GET_RELATION_LIST = gql`
  query getFamilyRelationList {
    getFamilyRelationList
  }
`

export const GET_BUSINESS_TYPES = gql`
  query getActiveBusinessTypes {
    getActiveBusinessTypes {
      id
      businessName
      isActive
    }
  }
`

export const SYSTEM_MODULE_LIST = gql`
  query getSystemModuleList($limit: Int!, $page: Int!) {
    getSystemModuleList(listFilter: {page: $page, limit: $limit}) {
      data {
        id
        moduleName
        modulePath
        moduleDescription
        moduleType
        modulePermissions {
          permissionName
          permissionSlug
          isActive
        }
      }
      total
      pageSize
      page
      totalPages
    }
  }
`
export const GET_SYSTEM_MODULE_BY_ID = gql`
  query getSystemModule($id: ID!) {
    getSystemModule(id: $id) {
      id
      moduleName
      modulePath
      moduleDescription
      moduleType
      modulePermissions {
        permissionName
        permissionSlug
        isActive
      }
    }
  }
`

export const GET_MY_PROFILE = gql`
  query getMyUserProfile($userId: ID) {
    getMyUserProfile(userId: $userId) {
      userProfile {
        firstName
        lastName
        email
        dob
        gender
        bloodGroup
        profilePhoto
        userTechDetails {
          specialty
        }
      }
      userAddress {
        id
        zipCode
        street
        city
        district
        state
        country
      }
      mobileNumber
      countryCode
    }
  }
`

export const UPLOAD_FILE = gql`
  mutation uploadFileInOnlyS3($documentDetail: FileInput!) {
    uploadFileInOnlyS3(documentDetail: $documentDetail)
  }
`
export const GET_BLOOD_GROUP_LIST = gql`
  query {
    getBloodGroupList {
      id
      bloodGroupName
    }
  }
`

export const GET_SAMPLE_FILE_URL = gql`
  query getSampleDownloadableFileUrl($fileKey: sampleFileKeyEnum!) {
    getSampleDownloadableFileUrl(fileKey: $fileKey) {
      EXCEL
      CSV
    }
  }
`
